export default "__VITE_ASSET__pWH5wiki__"